import React from "react";
import { Button, DatePicker } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Icons from "components/icons";
import { Localize } from "components/service";


const StaffCheckInHistoryTableFilter = ({ period, onChange }) => {
    const hasPeriod = !!period?.length;
    const periodLabel = Localize({ children: "STAFF_MANAGEMENT.Filter_SelectPeriod" }).props.children;

    return (
        <div className="d-flex align-items-center table-action-bar form-controls-compact staff-table-filter">
            <div className="d-flex align-items-center table-filter-form staff-table-filter__controls">
                <DatePicker.RangePicker
                    allowClear
                    clearIcon={ <CloseOutlined /> }
                    className={ `staff-audit-filter__period${
                        hasPeriod ?
                            " staff-audit-filter__period--chosen staff-filter-control--selected" :
                            " range-picker-single-placeholder"
                    }` }
                    format="DD.MM.YYYY"
                    separator="—"
                    suffixIcon={ hasPeriod ? null : <Icons.StaffCalendar /> }
                    placeholder={ [ periodLabel, "" ] }
                    value={ hasPeriod ? period : undefined }
                    onChange={ (value) => onChange(value || []) } />
                { hasPeriod &&
                    <Button className="btn-text-link" type="link" onClick={ () => onChange([]) }>
                        <Localize>STAFF_MANAGEMENT.Action_ClearAll</Localize>
                    </Button>
                }
            </div>
        </div>
    );
};

export default StaffCheckInHistoryTableFilter;
